export default [
  {
    path: '/governorates',
    name: 'governorate-list',
    props: true,
    component: () => import('@/views/location/governorates/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des Gouvernorats',
      pageDesc: 'Consultez, filtrez et gérez les gouvernorats. Utilisez les filtres pour affiner la liste et accédez aux détails de chaque gouvernorat.',
      ariaLabel: 'Tableau des gouvernorats',
      breadcrumb: [
        {
          text: 'Gouvernorats',
          to: { name: 'governorate-list' },
          ariaLabel: 'Retour à la liste des gouvernorats',
        },
        {
          text: 'Liste des Gouvernorats',
          active: true,
          ariaLabel: 'Page active : liste des gouvernorats',
        },
      ],
      breadcrumbLabel: 'Liste des Gouvernorats',
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/governorates/create',
    name: 'governorate-add',
    props: true,
    component: () => import('@/views/location/governorates/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter un Gouvernorat',
      pageDesc: 'Ajoutez un nouveau gouvernorat en renseignant son nom. Utilisez une désignation officielle et unique.',
      ariaLabel: 'Formulaire d’ajout de gouvernorat',
      breadcrumb: [
        {
          text: 'Gouvernorats',
          to: { name: 'governorate-list' },
          ariaLabel: 'Retour à la liste des gouvernorats',
        },
        {
          text: 'Ajouter Gouvernorat',
          active: true,
          ariaLabel: 'Page active : ajout gouvernorat',
        },
      ],
      breadcrumbLabel: 'Ajouter gouvernorat',
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/governorates/detail/:id',
    name: 'governorate-detail',
    props: true,
    component: () => import('@/views/location/governorates/Detail.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Détails du Gouvernorat',
      pageDesc: 'Consultez les informations détaillées, statistiques et délégations du gouvernorat sélectionné.',
      ariaLabel: 'Détails du gouvernorat',
      breadcrumb: [
        {
          text: 'Gouvernorats',
          to: { name: 'governorate-list' },
          ariaLabel: 'Retour à la liste des gouvernorats',
        },
        {
          text: 'Détails du gouvernorat',
          active: true,
          ariaLabel: 'Page active : détails gouvernorat',
        },
      ],
      breadcrumbLabel: 'Détails gouvernorat',
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/governorates/edit/:id',
    name: 'governorate-edit',
    props: true,
    component: () => import('@/views/location/governorates/Edit.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Modifier un Gouvernorat',
      pageDesc: 'Modifiez le nom du gouvernorat sélectionné. Utilisez une désignation officielle et unique.',
      ariaLabel: 'Formulaire de modification de gouvernorat',
      breadcrumb: [
        {
          text: 'Gouvernorats',
          to: { name: 'governorate-list' },
          ariaLabel: 'Retour à la liste des gouvernorats',
        },
        {
          text: 'Modifier Gouvernorat',
          active: true,
          ariaLabel: 'Page active : modification gouvernorat',
        },
      ],
      breadcrumbLabel: 'Modifier gouvernorat',
      roles: ['admin', 'superadmin'],
    },
  },
]
